/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditSpotAuditSpotMatchesListQueryResponse, AuditSpotAuditSpotMatchesListQueryParams } from "../models/AuditSpotAuditSpotMatchesList";

export function getAuditSpotAuditSpotMatchesListUrl() {
  const res = { method: 'GET', url: `/audit-spot/v1/matches` as const }
  return res
}

/**
 * @description Returns paginated spot matches using the mi-api CRUD list contract. Requires `filter=datetime||$gte||<from>` and `filter=datetime||$lte||<to>`. Optional filters: `customId||$eq||<id>`. Sort with `sort=datetime,ASC|DESC`.
 * @summary List spot matches
 * {@link /audit-spot/v1/matches}
 */
export async function auditSpotAuditSpotMatchesList(params: AuditSpotAuditSpotMatchesListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditSpotAuditSpotMatchesListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAuditSpotAuditSpotMatchesListUrl().url.toString(), params, ... requestConfig })
  return res.data
}